import styled from 'styled-components';

export const HeaderImage = styled.img`
  width: ${props => (props.center ? '520px' : '300px')};
  height: ${props => (props.center ? '130px' : '70px')};
`;
